import at from 'lodash-es/at'
import { Props } from './types'

export const prop =
  <T extends Props = Props>(selector: ((props: T) => any) | keyof T | string) =>
  (props: T) =>
    typeof selector === 'function' ? selector(props) : at(props, selector)[0]

export default prop
